import { useEffect, useMemo, useState } from 'react';
import { useQueryParams } from '@/hooks';
import { UsersFilter } from '../models';
import { UserStatus } from '../enums';
import type { UserTypeFilter } from '../enums/UserType';

const USER_TYPES: UserTypeFilter[] = ['commerce', 'operator', 'external_operator'];

const useUsersFilter = () => {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: UsersFilter = useMemo(
    () => ({
      search: '',
      phoneNumber: '',
      userType: '',
      status: undefined,
    }),
    []
  );

  const [filter, setFilter] = useState<UsersFilter>(() => {
    const statusParam = getQueryParam('status');
    const status: UserStatus | undefined =
      statusParam && Object.values(UserStatus).includes(statusParam as UserStatus)
        ? (statusParam as UserStatus)
        : undefined;

    const userTypeParam = getQueryParam('userType');
    const userType: UserTypeFilter | '' =
      userTypeParam && USER_TYPES.includes(userTypeParam as UserTypeFilter)
        ? (userTypeParam as UserTypeFilter)
        : '';

    return {
      search: getQueryParam('search') || '',
      phoneNumber: getQueryParam('phoneNumber') || '',
      userType,
      status,
    };
  });

  useEffect(() => {
    setQueryParams({
      search: filter.search || undefined,
      phoneNumber: filter.phoneNumber || undefined,
      userType: filter.userType || undefined,
      status: filter.status || undefined,
    });
  }, [filter]);

  return { filter, initialFilter, setFilter };
};

export default useUsersFilter;
